const TOGGLE_GIS_MODAL = 'app/modal/TOGGLE_GIS_MODAL';

export default {
  TOGGLE_GIS_MODAL
};
